import { Box, Button, Grid, Input, Label, Stack } from 'TBM/OldSharedUI';
import { useLoop } from 'loop/context';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';

type FormData = {
  email: string;
  password: string;
};

export function SigninForm() {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>();
  const { signIn } = useLoop();
  const router = useRouter();

  const onSubmit = handleSubmit((formData) => {
    return signIn({ email: formData.email, password: formData.password })
      .then(() => handleRedirect())
      .catch(() =>
        alert(
          router.locale?.startsWith('it')
            ? 'Username o Password errati.'
            : 'Credentials Wrong.'
        )
      );
  });

  const handleRedirect = () => {
    if (
      'redirectTo' in router.query &&
      typeof router.query.redirectTo === 'string'
    ) {
      router.push(router.query.redirectTo);
    } else {
      router.push('/');
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Grid gridGap={6} mt={6}>
        <Box>
          <Label mb={3}>Email</Label>
          <Input
            type="email"
            placeholder="hello@example.com"
            {...register('email')}
          />
        </Box>

        <Box>
          <Label mb={3}>Password</Label>
          <Input
            type="password"
            placeholder="Password"
            {...register('password')}
          />
          <Link passHref href="/v2/forgot-password">
            <Box as="a" fontSize={0} textAlign="right" mt={1}>
              {router.locale?.startsWith('it')
                ? 'Password dimenticata?'
                : 'Forgot password?'}
            </Box>
          </Link>
        </Box>

        <Stack flexDirection="column" gap={5}>
          <Button type="submit" variant="accent" disabled={isSubmitting}>
            Log In
          </Button>

          <Button
            onClick={() => router.push('/v2/signup')}
            type="button"
            disabled={isSubmitting}
          >
            Sign Up
          </Button>
        </Stack>
      </Grid>
    </form>
  );
}
